export default "__VITE_ASSET__sBkCfTLs__"